// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer {
  justify-content: flex-end;
  border: 0px;
  margin: 22px;
  padding: 0;
}

.modal-body {
  margin: 20px 22px 30px 22px;
  padding: 0;
}

.title {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.label {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/add-contact/add-contact.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,2BAAA;EACA,UAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AACJ","sourcesContent":[".modal-footer {\n    justify-content: flex-end;\n    border: 0px;\n    margin: 22px;\n    padding: 0;\n}\n\n.modal-body {\n    margin: 20px 22px 30px 22px;\n    padding: 0;\n}\n\n.title {\n    color: #3E0D42;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n}\n\n.label {\t\n    color: #3E0D42;\t\n    font-size: 11px;\t\n    font-weight: bold;\t\n    letter-spacing: 0.39px;\t\n    line-height: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
